export const CHANNEL_JOIN_CODE_TYPES = Object.freeze({
  ENABLED: "enabled",
  DISABLED: "disabled",
  REQUIRES_APPROVAL: "requires_approval",
});